<template>
    <div class="biz-personal-center parent-frame">
        <div class="biz-personal-center-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .biz-personal-center{
        position: relative;
        .biz-personal-center-wrap{
            padding-left: 30px;
            padding-right: 30px;
            width:  calc(1180px - 40px);
        }
    }
    @media screen and (max-width: 1280px){
        .biz-personal-center{
            .biz-ipersonal-center-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalCenter/personalCenterFrame.vue